/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	PoliJobsCvAccessReportDTO,
	PoliJobsCvAccessReportDTOFromJSON,
	PoliJobsCvAccessReportDTOFromJSONTyped,
	PoliJobsCvAccessReportDTOToJSON,
} from "./PoliJobsCvAccessReportDTO";

/**
 *
 * @export
 * @interface PoliJobsCvAccessReportDTOPagedResponse
 */
export interface PoliJobsCvAccessReportDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsCvAccessReportDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsCvAccessReportDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsCvAccessReportDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<PoliJobsCvAccessReportDTO>}
	 * @memberof PoliJobsCvAccessReportDTOPagedResponse
	 */
	data?: Array<PoliJobsCvAccessReportDTO> | null;
}

export function PoliJobsCvAccessReportDTOPagedResponseFromJSON(
	json: any
): PoliJobsCvAccessReportDTOPagedResponse {
	return PoliJobsCvAccessReportDTOPagedResponseFromJSONTyped(json, false);
}

export function PoliJobsCvAccessReportDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PoliJobsCvAccessReportDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(PoliJobsCvAccessReportDTOFromJSON),
	};
}

export function PoliJobsCvAccessReportDTOPagedResponseToJSON(
	value?: PoliJobsCvAccessReportDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(PoliJobsCvAccessReportDTOToJSON),
	};
}
